import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Vue from 'vue';
import EnqueteApp from '../enquete/components/EnqueteApp';

const loginData = {
  startDate: '20191225',
  endDate: '20221224',
  title: '新型コロナウイルスに関する無料相談',
  text: '新型コロナウイルスに関する相談事例の閲覧や医師相談が無料でできます。',
  linkUrl: '/open/COVID-19-usage',
  linkText: '詳細・相談はこちらから',
  displayTargetCode: 1,
  validPath: ['/']
};

const notLoginData = {
  startDate: '20191225',
  endDate: '20221224',
  title: '新型コロナウイルスに関する無料相談',
  text:
    '無料で相談事例の閲覧や医師相談ができます。会員の方はログインをしてください。',
  linkUrl: '/open/COVID-19-usage',
  linkText: '詳細・相談はこちらから',
  displayTargetCode: 2,
  validPath: ['/']
};

const loginEnqueteApp = new Vue({
  render: h => h(EnqueteApp, { props: loginData })
});

const notLoginEnqueteApp = new Vue({
  render: h => h(EnqueteApp, { props: notLoginData })
});

document.addEventListener('DOMContentLoaded', () => {
  const login = document
    .getElementById('enquete-app')
    ?.getAttribute('data-login');
  if (login === 'true') {
    loginEnqueteApp.$mount('#enquete-app');
  } else {
    notLoginEnqueteApp.$mount('#enquete-app');
  }
});
